// frontend/src/store.js
import { apiSlice } from './slices/apiSlice';
import { configureStore } from '@reduxjs/toolkit';
import modeSlice from './slices/modeSlice';
import authSlice from './slices/authSlice';
import productGroupSlice from './slices/store/productGroupSlice';
import { productGroupApiSlice } from './slices/store/productGroupApiSlice';

const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [productGroupApiSlice.reducerPath]: productGroupApiSlice.reducer, // Добавляем новый API слайс
    mode: modeSlice,
    auth: authSlice,
    productGroups: productGroupSlice, // Добавляем редьюсер групп товаров
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(apiSlice.middleware)
      .concat(productGroupApiSlice.middleware), // Добавляем middleware для нового API
  //devTools: true,
});

export default store;
